export default __webpack_public_path__ + "aa4e13c9c924cd916eacfbdb1342985f.webp";